export const inputClasses = {
  base: 'w-full rounded-lg border pr-10 focus:ring-2 cursor-pointer bg-white',
  size: {
    sm: 'text-sm px-3 py-2',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-5 py-3',
  },
  status: {
    error: 'border-red-500 focus:ring-red-500',
    success: 'border-gray-300 focus:ring-blue-500',
  },
  disabled: 'opacity-50 cursor-not-allowed',
}

export const calendarIconClasses = {
  base: 'absolute inset-y-0 right-8 flex items-center px-2 cursor-pointer',
  status: {
    error: 'text-red-500',
    success: 'text-gray-500',
  },
  disabled: 'opacity-50 cursor-not-allowed',
}

export const clearButtonClasses = {
  base: 'absolute inset-y-0 right-2 flex items-center justify-center w-5 h-5 my-auto rounded-full hover:bg-gray-300',
  status: {
    error: 'bg-red-200 text-red-500 hover:text-red-700',
    success: 'bg-gray-200 text-gray-500 hover:text-gray-700',
  },
  disabled: 'opacity-50 cursor-not-allowed',
}
